import Vue from 'vue';
import { quizier } from './index';
import { modules } from './modules';
import VueInternationalization from 'vue-i18n';
import * as VueDeepSet from 'vue-deepset';
import Vuelidate from 'vuelidate';
import InArticleAdsense from 'vue-google-adsense/dist/InArticleAdsense.min.js'
import "babel-polyfill";

Vue.use(require('vue-script2'))

Vue.prototype.svg = require('./assets/svgs/svg');
Vue.use(VueInternationalization);
Vue.use(VueDeepSet);
Vue.use(Vuelidate);
Vue.use(InArticleAdsense)

const lang = document.documentElement.lang.substr(0, 2);
const i18n = new VueInternationalization({
    locale: lang,
    messages: vuei18nLocales
});

Vue.prototype.$variables = JSON.parse(JSON.stringify(window.variables));

const hasPost = typeof postData !== 'undefined';
const postBlocks = hasPost ? JSON.parse(JSON.stringify(postData.blocks)) : [];
const postSettings = hasPost ? JSON.parse(JSON.stringify(postData.settings)) : {};
const postID = hasPost && typeof postData.post_id !== 'undefined' ? postData.post_id : false;
const post_pagination = typeof window.variables.post_pagination !== 'undefined' ? window.variables.post_pagination : true;
const page = post_pagination && hasPost && typeof postData.page !== 'undefined' ? postData.page : 1;
const total_pages = hasPost && typeof postData.total_pages !== 'undefined' ? postData.total_pages : 1;
const default_language = window.variables.current_locale ? window.variables.current_locale : lang;
const locales_keys = window.variables.locales_keys ? JSON.parse(window.variables.locales_keys) : [lang];
const isPreview = typeof postData !== 'undefined' && typeof postData.is_preview !== 'undefined' ? postData.is_preview : false;
window.blockCounter = 0;

Vue.use(quizier, {
    defaultLanguage: default_language,
    isPreview: isPreview,
    languages: locales_keys,
    blocks: postBlocks,
    settings: postSettings,
    modules: modules,
    post: postID,
    post_pagination: post_pagination,
    page: page,
    total_pages: total_pages
});

new Vue({
    el: '#viewer',
    i18n,
});
